import { render, staticRenderFns } from "./WelcomeMedsurlink.vue?vue&type=template&id=554fc7f5&lang=true"
import script from "./WelcomeMedsurlink.vue?vue&type=script&lang=js"
export * from "./WelcomeMedsurlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports